module.exports = "<label data-bind=\"text: title\" for=\"reportsTo\"></label>\n<input type=\"text\" data-bind=\"click: clickEditOption, visible: editMode() == false, value: selectedLabel, enabled: false\" class=\"form-control\"  placeholder=\"\">\n<select class=\"form-control\" data-bind=\"visible: editMode() == true, event: {blur: toggleEditMode, change: updateSelected}, value:selected, options: data, optionsText: 'label', optionsCaption: 'n/a'\"> </select>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/components/options/customOptionsInline/customOptionsInline.html
// module id = 663
// module chunks = 0